<template>
  <div>
    <el-drawer :visible.sync="changVisible" :title="title" size="300px" :before-close="$onClose" destroy-on-close>
      <el-checkbox-group v-model="checkList">
        <div>
          <el-checkbox label="学号" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="中文姓名" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="英文姓名" disabled></el-checkbox>
        </div>
        <div>
          <el-checkbox label="专业"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="入学年份"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="状态"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="所在地"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="单位名称"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="单位性质"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="行业类型"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="工作职位"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="薪酬范围"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="公司注册地"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="雇员人数"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="年营业额"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="从事何种自由职业"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="联系电话"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="微信"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="生源地"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="校友类别"></el-checkbox>
        </div>
        <div>
          <el-checkbox label="是否本硕连读"></el-checkbox>
        </div>
      </el-checkbox-group>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      changVisible: false,
      title: '勾选表格显示字段',
      checkList: []
    }
  },
  methods: {
    $onClose(done) {
      this.$emit('toBackCheckList', this.checkList)
      done()
    },
    //页面初始化时加载的事件
    show(list) {
      this.checkList = list
      this.changVisible = true
    },
    // 还原
    onBack() {
      this.changVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
div {
  margin-left: 30px;
}
.this_table {
  width: 50%;
  margin: 0 auto;
}
.btn_back {
  float: right;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/drawer/jobsTableLabelDrawer.vue